"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const OWM_MAP = {
    day: {
        200: { icon: 'thunderstorm' },
        201: { icon: 'thunderstorm' },
        202: { icon: 'thunderstorm' },
        210: { icon: 'lightning' },
        211: { icon: 'lightning' },
        212: { icon: 'lightning' },
        221: { icon: 'lightning' },
        230: { icon: 'thunderstorm' },
        231: { icon: 'thunderstorm' },
        232: { icon: 'thunderstorm' },
        300: { icon: 'sprinkle' },
        301: { icon: 'sprinkle' },
        302: { icon: 'rain' },
        310: { icon: 'rain' },
        311: { icon: 'rain' },
        312: { icon: 'rain' },
        313: { icon: 'rain' },
        314: { icon: 'rain' },
        321: { icon: 'sprinkle' },
        500: { icon: 'sprinkle' },
        501: { icon: 'rain' },
        502: { icon: 'rain' },
        503: { icon: 'rain' },
        504: { icon: 'rain' },
        511: { icon: 'rain-mix' },
        520: { icon: 'showers' },
        521: { icon: 'showers' },
        522: { icon: 'showers' },
        531: { icon: 'storm-showers' },
        600: { icon: 'snow' },
        601: { icon: 'sleet' },
        602: { icon: 'snow' },
        611: { icon: 'rain-mix' },
        612: { icon: 'rain-mix' },
        615: { icon: 'rain-mix' },
        616: { icon: 'rain-mix' },
        620: { icon: 'rain-mix' },
        621: { icon: 'snow' },
        622: { icon: 'snow' },
        701: { icon: 'showers' },
        711: { icon: 'smoke' },
        721: { icon: 'haze' },
        731: { icon: 'dust' },
        741: { icon: 'fog' },
        761: { icon: 'dust' },
        762: { icon: 'dust' },
        781: { icon: 'tornado' },
        800: { icon: 'sunny' },
        801: { icon: 'cloudy-gusts' },
        802: { icon: 'cloudy-gusts' },
        803: { icon: 'cloudy-gusts' },
        804: { icon: 'sunny-overcast' },
        900: { icon: 'tornado' },
        902: { icon: 'hurricane' },
        903: { icon: 'snowflake-cold' },
        904: { icon: 'hot' },
        906: { icon: 'hail' },
        957: { icon: 'strong-wind' },
    },
    night: {
        200: { icon: 'alt-thunderstorm' },
        201: { icon: 'alt-thunderstorm' },
        202: { icon: 'alt-thunderstorm' },
        210: { icon: 'alt-lightning' },
        211: { icon: 'alt-lightning' },
        212: { icon: 'alt-lightning' },
        221: { icon: 'alt-lightning' },
        230: { icon: 'alt-thunderstorm' },
        231: { icon: 'alt-thunderstorm' },
        232: { icon: 'alt-thunderstorm' },
        300: { icon: 'alt-sprinkle' },
        301: { icon: 'alt-sprinkle' },
        302: { icon: 'alt-rain' },
        310: { icon: 'alt-rain' },
        311: { icon: 'alt-rain' },
        312: { icon: 'alt-rain' },
        313: { icon: 'alt-rain' },
        314: { icon: 'alt-rain' },
        321: { icon: 'alt-sprinkle' },
        500: { icon: 'alt-sprinkle' },
        501: { icon: 'alt-rain' },
        502: { icon: 'alt-rain' },
        503: { icon: 'alt-rain' },
        504: { icon: 'alt-rain' },
        511: { icon: 'alt-rain-mix' },
        520: { icon: 'alt-showers' },
        521: { icon: 'alt-showers' },
        522: { icon: 'alt-showers' },
        531: { icon: 'alt-storm-showers' },
        600: { icon: 'alt-snow' },
        601: { icon: 'alt-sleet' },
        602: { icon: 'alt-snow' },
        611: { icon: 'alt-rain-mix' },
        612: { icon: 'alt-rain-mix' },
        615: { icon: 'alt-rain-mix' },
        616: { icon: 'alt-rain-mix' },
        620: { icon: 'alt-rain-mix' },
        621: { icon: 'alt-snow' },
        622: { icon: 'alt-snow' },
        701: { icon: 'alt-showers' },
        711: { icon: 'smoke' },
        721: { icon: 'day-haze' },
        731: { icon: 'dust' },
        741: { icon: 'fog' },
        761: { icon: 'dust' },
        762: { icon: 'dust' },
        781: { icon: 'tornado' },
        800: { icon: 'clear' },
        801: { icon: 'alt-cloudy-gusts' },
        802: { icon: 'alt-cloudy-gusts' },
        803: { icon: 'alt-cloudy-gusts' },
        804: { icon: 'alt-cloudy' },
        900: { icon: 'tornado' },
        902: { icon: 'hurricane' },
        903: { icon: 'snowflake-cold' },
        904: { icon: 'hot' },
        906: { icon: 'alt-hail' },
        957: { icon: 'strong-wind' },
    },
};
exports.default = OWM_MAP;
